import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../store/sagas';
import { Fn_AddEditData, Fn_DeleteData } from '../helpers/Functions';
import { fetchAndSyncCart } from '../helpers/cartFetcher';
import { API_WEB_URLS } from '../constants/constAPI';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import productReducer from './Reducers/product-slice';
import currencyReducer from "./Reducers/currency-slice";
import cartReducer from "./Reducers/cart-slice";
import compareReducer from "./Reducers/compare-slice";
import wishlistReducer from "./Reducers/wishlist-slice";

const persistConfig = {
    key: "flone",
    version: 1.1,
    storage,
    blacklist: ["product"]
}

export const rootReducer = combineReducers({
    product: productReducer,
    currency: currencyReducer,
    cart: cartReducer,
    compare: compareReducer,
    wishlist: wishlistReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();

const cartApiMiddleware = store => next => action => {
    let userId = "0";
    let userToken = "token";
    const userDataStr = localStorage.getItem("userData");
    if (userDataStr) {
        try {
            const userData = JSON.parse(userDataStr);
            const actualData = userData.data?.response?.[0] || userData.response?.[0] || userData[0] || userData;
            
            const parsedId = actualData.Id || actualData.id || actualData.UserId;
            if (parsedId && String(parsedId).trim() !== "") {
                userId = String(parsedId).trim();
            }

            const parsedToken = actualData.Token || actualData.token || actualData.UserToken;
            if (parsedToken && String(parsedToken).trim() !== "") {
                userToken = String(parsedToken).trim();
            }
        } catch (e) {}
    }

    if (userDataStr && userId !== "0") {
        if (action.type === 'cart/addToCart') {
            const product = action.payload;
            const qty = product.quantity || 1;
            let designMasterId = 0;
            
            if (product.designDetails && product.designDetails.length > 0) {
                designMasterId = product.designDetails[0].Id || 0;
            } else if (product.id) {
                const numericId = parseInt(product.id, 10);
                if (!isNaN(numericId)) designMasterId = numericId;
            }

            const formData = new FormData();
            formData.append("Id", "0");
            formData.append("F_ItemDesignMaster", String(designMasterId));
            formData.append("Qty", String(qty));

            const url = `${API_WEB_URLS.BASE}Cart/${userId}/${userToken}`;
            
            Fn_AddEditData(store.dispatch, null, { arguList: { formData, id: 0 } }, url, true, null, null, null)
                .then(res => {
                    console.log("Cart API success:", res);
                    fetchAndSyncCart(store.dispatch);
                })
                .catch(err => console.error("Cart API error:", err));
        } else if (action.type === 'cart/deleteFromCart') {
            const cartItemId = action.payload;
            if (cartItemId && String(cartItemId).trim() !== "") {
                const url = `${API_WEB_URLS.BASE}Cart/${userId}/${userToken}`;
                Fn_DeleteData(store.dispatch, () => {}, cartItemId, url, null)
                    .then(res => {
                        console.log("Cart Delete success:", res);
                        fetchAndSyncCart(store.dispatch);
                    })
                    .catch(err => console.error("Cart Delete error:", err));
            }
        } else if (action.type === 'cart/decreaseQuantity') {
            const product = action.payload;
            if (product.quantity === 1) {
                // It will be deleted from local state, so delete from API
                const cartItemId = product.cartItemId;
                if (cartItemId && String(cartItemId).trim() !== "") {
                    const url = `${API_WEB_URLS.BASE}Cart/${userId}/${userToken}`;
                    Fn_DeleteData(store.dispatch, () => {}, cartItemId, url, null)
                        .then(res => {
                            console.log("Cart Delete success (decreased to 0):", res);
                            fetchAndSyncCart(store.dispatch);
                        })
                        .catch(err => console.error("Cart Delete error:", err));
                }
            } else {
                // It will be decremented in local state. Send Qty: -1 to API.
                let designMasterId = 0;
                if (product.designDetails && product.designDetails.length > 0) {
                    designMasterId = product.designDetails[0].Id || 0;
                } else if (product.id) {
                    const numericId = parseInt(product.id, 10);
                    if (!isNaN(numericId)) designMasterId = numericId;
                }
                const formData = new FormData();
                formData.append("Id", "0");
                formData.append("F_ItemDesignMaster", String(designMasterId));
                formData.append("Qty", "-1"); // Send -1 to decrement

                const url = `${API_WEB_URLS.BASE}Cart/${userId}/${userToken}`;
                Fn_AddEditData(store.dispatch, null, { arguList: { formData, id: 0 } }, url, true, null, null, null)
                    .then(res => {
                        console.log("Cart API decrease success:", res);
                        fetchAndSyncCart(store.dispatch);
                    })
                    .catch(err => console.error("Cart API decrease error:", err));
            }
        }
    }
    return next(action);
};

export const Store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(sagaMiddleware, cartApiMiddleware),
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(Store);
